<div *ngIf="!loginDisplay">
    <p class="welcome">Welcome to the Config Comparison Tool!</p>
    <p>Please sign-in to start.</p>
</div>

<div *ngIf="loginDisplay">
    <app-comparison></app-comparison>
</div>